export enum TransactionEventEnum {
  BUY = 'BUY',
  SELL = 'SELL',
}
